export default "__VITE_ASSET__BeQddp8M__"